import { render, staticRenderFns } from "./TransactionInternalReference.vue?vue&type=template&id=94f353c2&"
import script from "./TransactionInternalReference.vue?vue&type=script&lang=js&"
export * from "./TransactionInternalReference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports